module.exports = __webpack_public_path__ + "img/404.8d348d56.png";